var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 mx-auto"},[_c('div',{staticClass:"d-flex flex-column justify-content-center align-items-center h-100 m-5"},[_c('h1',{staticClass:"mb-4"},[_vm._v("Aguarde")]),_c('h3',[_vm._v("Carregando Informações")]),_c('Loader')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }